export const formatPrintAmount = (value) => {
  if (value == null || value === "") return "-";
  const num = Number(value);
  if (Number.isNaN(num)) return "-";
  return num.toFixed(2);
};

/** Signed money for print: -45.85$ / 45.85$ (dollar after the number). */
export const formatPrintMoney = (value) => {
  if (value == null || value === "") return "";
  const num = Number(value);
  if (Number.isNaN(num)) return String(value);
  const abs = Math.abs(num).toFixed(2);
  return num < 0 ? `-${abs}$` : `${abs}$`;
};

export const resolveTeacherHalfYearData = (records, yearKey) => {
  if (!records || yearKey === undefined || yearKey === null || yearKey === "") {
    return {};
  }

  const list = Array.isArray(records)
    ? records.filter(Boolean)
    : Object.values(records || {});

  const index = parseInt(yearKey, 10);
  if (!Number.isNaN(index) && list[index]?.half_year) {
    return list[index];
  }

  const byHalfYear = list.find(
    (row) =>
      String(row.payable_half_year_id) === String(yearKey) ||
      String(row.half_year_id) === String(yearKey)
  );
  if (byHalfYear) return byHalfYear;

  if (!Number.isNaN(index) && list[index]) {
    return list[index];
  }

  return {};
};

export const getTeacherProfileRow = (records, filteredRow) => {
  if (filteredRow?.teacher_name) return filteredRow;
  const list = Array.isArray(records) ? records : Object.values(records || {});
  return list.find((row) => row?.teacher_name) || list[0] || {};
};

export const findFinancePayment = (payments, receiptId) => {
  const list = Array.isArray(payments) ? payments : [];
  let found = list.find((p) => String(p.id) === String(receiptId));
  if (found) return found;

  const halfYearMatches = list.filter(
    (p) => String(p.half_year_id) === String(receiptId)
  );
  if (halfYearMatches.length === 0) return null;

  return halfYearMatches.sort(
    (a, b) => new Date(b.payment_date) - new Date(a.payment_date)
  )[0];
};

export const paymentField = (payment, ...keys) => {
  for (const key of keys) {
    const value = payment?.[key];
    if (value != null && value !== "") return value;
  }
  return "";
};
